<nav class="navbar justify-content-center bg-color-from-db px-1">
  <div class="d-flex flex-row flex-wrap justify-content-center p-2">
    <button
      class="btn btn-color-from-db btn-lg m-2"
      (click)="goToInstructions()"
    >
      <em class="fa fa-book"></em>
      {{ getTranslateUsefulInfoNavInstructionKey() | async | translate }}
    </button>
    <button class="btn btn-color-from-db btn-lg m-2" (click)="goToFaq()">
      <em class="fa fa-question-circle"></em>
      {{
        'OFFICE_DEPARTMENTS_PORTAL.GEODESY.USEFUL_INFO_NAV.BUTTONS.FAQ'
          | translate
      }}
    </button>
    @if (isRequestsButtonVisible) {
      <button
        type="button"
        class="btn btn-color-from-db btn-lg m-2"
        (click)="showModalRequestsList()"
      >
        <em class="fa fa-file-pdf-o"></em>
        {{ getTranslateUsefulInfoNavRequestsKey() | translate }}
      </button>
    }

    @if (isDocumentVerificationButtonVisible) {
      <button
        type="button"
        class="btn btn-color-from-db btn-lg m-2"
        (click)="showModalDocumentVerification()"
      >
        <em class="fa fa-check-circle"></em>
        {{ getTranslateUsefulInfoNavDocVerificationKey() | translate }}
      </button>
    }
    <a
      class="btn btn-color-from-db btn-lg m-2"
      [href]="getTeamViewerDownloadUrl()"
    >
      <div class="remote-help-icon"></div>
      {{ getTranslateUsefulInfoNavRemoteHelpKey() | translate }}
    </a>
    @if (
      isAccessibilityStatementButtonVisible &&
      ((systemConfigBlobGuestService.getAccessibilityStatementHtmlContent()
        | async) ||
        (systemConfigBlobGuestService.getAccessibilityMobileStatementHtmlContent()
          | async))
    ) {
      <div
        class="btn btn-color-from-db btn-lg font-color-from-db dropdown dropup"
      >
        <div
          class="btn btn-color-from-db font-color-from-db btn-lg dropdown-toggle force-color-from-db"
          role="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          tabindex="0"
        >
          <em class="fa fa-universal-access"></em>
          {{ getTranslateUsefulInfoNavAccessibilityStatementKey() | translate }}
        </div>
        <div
          class="dropdown-menu p-0"
          aria-labelledby="dropdownMenuButton"
          role="menu"
        >
          @if (
            systemConfigBlobGuestService.getAccessibilityStatementHtmlContent()
              | async
          ) {
            <a
              class="btn btn-color-from-db w-100 force-color-from-db rounded-0"
              href="#"
              target="_blank"
              [routerLink]="['/accessibility-statement-regular']"
              role="menuitem"
              tabindex="0"
            >
              {{ 'DESKTOP_APPLICATION' | translate }}
            </a>
          }
          @if (
            systemConfigBlobGuestService.getAccessibilityMobileStatementHtmlContent()
              | async
          ) {
            <a
              class="btn btn-color-from-db w-100 force-color-from-db rounded-0"
              href="#"
              target="_blank"
              [routerLink]="['/accessibility-statement-mobile']"
              role="menuitem"
              tabindex="0"
            >
              {{ 'MOBILE_APPLICATION' | translate }}
            </a>
          }
        </div>
      </div>
    }
  </div>
</nav>

<app-modal-requests-list></app-modal-requests-list>
<app-modal-document-verification></app-modal-document-verification>
